import React, { useState, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import '../styles.css';
import PlanA from './plana';
import PlanB from './planb';

const PlanC = (props) =>
{
	const { planId, pack, setPack } = props;

	return (
		<Fragment>
			{pack === 'planA' ?
				<PlanA setPack={setPack} planId={planId} />
				: pack === 'planB' ?
					<PlanB setPack={setPack} planId={planId} />
					:
					<div className='flexCol alignCntr baseBg pdngLG dashboardCntnr'>
						<div className='flexCol alignCntr whiteTxt LinearGradientGreen brdrRadiusSM pdngXS'>
							<h3 className='fontWeightNormal textCntr'>1 KONX PACK FOR $250 AND 1 KONX ECARD PACK FOR $500</h3>
						</div>
						<div className='resRowColM justifyCntr alignCntr fullWidth pdngTMD mrgnTXLG'>
							<div className='flexMinWidthCol justifyBtwn alignCntr height300 pdngMD mrgnTXLG'>
								<div className='flexAutoCol'>
									<h3 className='mrgnTXLG textCntr'>1 KONX PACK FOR $250</h3>
									<div className='flexCol alignCntr pdngVSM'>
										<ul className='flexCol alignCntr featuresCntnr'>
											<li className='flexRow justifyCntr  textCntr pdngTSM'>7 Months of Personal Conference Room</li>
											<li className='flexRow justifyCntr  textCntr pdngTSM'> 6 Months of Basic PRO Conference Room</li>
											<li className='flexRow justifyCntr  textCntr pdngTSM'> 1 Months of Enterprise Conference Room</li>
										</ul>
									</div>
								</div>
								<div className='flexCol alignCntr resWidth35 LinearGradientGreen brdrRadiusSM mrgnVSM'>
									<Button className='whiteTxt' onClick={() => setPack('planA')}>
										View Licenses
									</Button>
								</div>
							</div>

							<div className='flexMinWidthCol justifyBtwn alignCntr height300 pdngMD mrgnTXLG'>
								<div className='flexAutoCol'>
									<h3 className='mrgnTXLG textCntr'>1 KONX ECARD PACK FOR $500</h3>
									<div className='flexCol alignCntr pdngVSM'>
										<ul className='flexCol alignCntr Cntnr'>
											<li className='flexRow justifyCntr  textCntr pdngVSM'> 13 KonX eCards</li>
											{/* (Personal Conference Room) */}
										</ul>
									</div>
								</div>
								<div className='flexCol alignCntr resWidth35 LinearGradientGreen brdrRadiusSM mrgnVSM'>
									<Button className='whiteTxt' onClick={() => setPack('planB')}>
										View Licenses
									</Button>
								</div>
							</div>
						</div>
						{/* <div className='flexCol justifyCntr alignCntr pdngVLG mrgnTLG redTxt'>
							<h3 className='textCntr'>USE THE SAME SAMPLE LINKS FROM THE PREVIOUS SLIDES</h3>
						</div>
						<div className='flexCol whiteTxt LinearGradientGreen brdrRadiusSM mrgnTSM txtleft'>
							<h4 className='pdngXXS'>www.konx.biz</h4>
						</div> */}
					</div>
			}
		</Fragment>
	);
};

export default PlanC;
